import { useTranslation } from 'react-i18next';
import './system-check.less';
import OctagonExclamation from '../../../assets/octagon-exclamation-red.svg';

function SystemCheckProgress(props:any) {
    const { t } = useTranslation();    
    
    return (
        <div role='status' aria-live='polite'>
            <div aria-hidden="true" className={props.notStarted ? 'system-check-progress-show' : 'system-check-progress-hide'}>
                <div className='system-check-icon-not-started'></div>
                <div className='system-check-progress' >{t('SYSTEM_CHECK_NOT_STARTED')}</div>
            </div>
            <div aria-hidden="true" className={props.inProgress ? 'system-check-progress-show' : 'system-check-progress-hide'}>
                <div className='system-check-icon-in-progress'>
                    <i className='fa-solid fa-circle-notch fa-spin fa-2xl'></i>
                </div>
                <div className='system-check-progress' >{t('SYSTEM_CHECK_IN_PROGRESS')}</div>
            </div>
            <div className={props.passed ? 'system-check-progress-show' : 'system-check-progress-hide'}>
                <div className='system-check-icon-passed'>
                    <i className='fa-solid fa-circle-check fa-2xl'></i>
                </div>
                <div className='screen-readers-only' >{props.name}</div>
                <div className='system-check-progress' >{t('SYSTEM_CHECK_PASSED')}</div>    
                <div className='screen-readers-only' >{props.value}</div>  
            </div>
            <div className={props.failed ? 'system-check-progress-show' : 'system-check-progress-hide'}>
                <div className='system-check-icon-failed'>
                <img aria-hidden='true' className='webcam-exclamation-icon' src={OctagonExclamation} alt="" />
                </div>
                <div className='screen-readers-only' >{props.name}</div>
                <div className='system-check-progress' >{t('SYSTEM_CHECK_FAILED')}</div>
                <div className='screen-readers-only' >{props.value}</div>      
            </div>
            <div className={props.warning ? 'system-check-progress-show' : 'system-check-progress-hide'}>
                <div className='system-check-icon-warning'>
                    <i className='fa-solid fa-triangle-exclamation fa-2xl'></i>
                </div>
                <div className='screen-readers-only' >{props.name}</div>
                <div className='system-check-progress' >{t('SYSTEM_CHECK_WARNING')}</div>
                <div className='screen-readers-only' >{props.value}</div>      
            </div>                    
        </div>
    );
}

export default SystemCheckProgress;